import { CalendarIcon, CampaignIcon, ClockIcon, RocketIcon, ShoppingBagIcon, UsersIcon } from 'assets/icons'
import type { TDatadogErrorLog } from 'utils/datadog/types'

import { translations } from './use-niche-context-manager.i18n'
import { SYSTEM_CONTEXT_IDS } from '../../niche.consts'
import type { DefaultContext } from '../../types'

export const MAX_CUSTOM_CONTEXTS = 15

export const DEFAULT_CONTEXTS: DefaultContext[] = [
  {
    id: SYSTEM_CONTEXT_IDS.happeningNow,
    name: '',
    translation: translations.happeningNow,
    icon: <ClockIcon />,
    hash: null,
  },
  {
    id: SYSTEM_CONTEXT_IDS.mostEngaged,
    name: '',
    translation: translations.mostEngaged,
    icon: <RocketIcon />,
    hash: null,
  },
  {
    id: SYSTEM_CONTEXT_IDS.products,
    name: '',
    translation: translations.products,
    icon: <ShoppingBagIcon />,
    hash: null,
  },
  {
    id: SYSTEM_CONTEXT_IDS.campaignsAndPublicity,
    name: '',
    translation: translations.campaingsAdvertising,
    icon: <CampaignIcon />,
    hash: null,
  },
  {
    id: SYSTEM_CONTEXT_IDS.eventsAndCommemorativeDates,
    name: '',
    translation: translations.events,
    icon: <CalendarIcon />,
    hash: null,
  },
  {
    id: SYSTEM_CONTEXT_IDS.socialIssues,
    name: '',
    translation: translations.socialIssues,
    icon: <UsersIcon />,
    hash: null,
  },
]

export const GET_TERRITORY_NICHE_CONTEXTS_LOG: TDatadogErrorLog = {
  from: 'src/modules/niche/common/hooks/use-niche-context-manager/index.ts',
  name: 'Get Territory Niche Contexts',
  message: 'Failed to fetch list of niche contexts for a territory',
}

export const DELETE_TERRITORY_NICHE_CONTEXT_LOG: TDatadogErrorLog = {
  from: 'src/modules/niche/common/hooks/use-niche-context-manager/index.ts',
  name: 'Delete Territory Niche Context',
  message: 'Failed to delete the niche context of a territory',
}

export const CREATE_TERRITORY_NICHE_CONTEXT_LOG: TDatadogErrorLog = {
  from: 'src/modules/niche/common/hooks/use-niche-context-manager/index.ts',
  name: 'Create Territory Niche Context',
  message: 'Failed to create a niche context for a territory',
}

export const CREATE_TERRITORY_NICHE_CONTEXT_HASH_LOG: TDatadogErrorLog = {
  from: 'src/modules/niche/common/hooks/use-niche-context-manager/index.ts',
  name: 'Create Territory Niche Context Hash',
  message: 'Failed to create a niche context hash for a territory',
}
